import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { formatCFA } from '@/lib/utils'
import type { BarDatumNV } from '@/types/backend'
import { ResponsiveBar } from '@nivo/bar'
import React from 'react'

type BilanTopClientsProps = {
  gridColor: string
  gridOpacity: number
  data: BarDatumNV[]
  emptyMsg?: string
}

const BilanTopClients: React.FC<BilanTopClientsProps> = ({
  gridColor,
  gridOpacity,
  data,
  emptyMsg = '',
}) => {
  const safeData = data.length ? data : [{ name: '', value: 0 }]
  return (
    <Card className='min-h-[360px]'>
      <CardHeader>
        <h4 className='text-lg font-medium'>Top clients (ventes)</h4>
      </CardHeader>
      <CardContent className='h-[300px]'>
        <ResponsiveBar
          data={safeData}
          keys={['value']}
          indexBy='name'
          layout='vertical'
          margin={{ top: 10, right: 10, bottom: 40, left: 48 }}
          padding={0.3}
          borderRadius={6}
          axisBottom={{ tickPadding: 12, tickRotation: -10 }}
          axisLeft={{ tickPadding: 6 }}
          enableLabel={false}
          theme={{
            grid: {
              line: { stroke: gridColor, strokeOpacity: gridOpacity },
            },
            tooltip: { container: { fontSize: 12, borderRadius: 8 } },
          }}
          colors={['#3b82f6']}
          tooltip={({ value, indexValue }) => (
            <div className='rounded-md border bg-white p-2 text-xs shadow'>
              <div>
                Client: <b>{String(indexValue)}</b>
              </div>
              <div>
                Ventes: <b>{formatCFA(Number(value))}</b>
              </div>
            </div>
          )}
        />
        {!data?.length && (
          <div className='mt-2 text-center text-xs text-muted-foreground'>
            {emptyMsg}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default BilanTopClients
